import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 28BCDF41-AA93-4C25-B87A-95A3F5DD8805
 * name rewind
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rewind.svg
 * tags
 */
export const RewindIcon = createSvgIcon(<><path d="M11.5,12L20,18V6M11,18V6L2.5,12L11,18Z" /></>, 'RewindIcon');
export default RewindIcon